import { render, staticRenderFns } from "./JournalOrgSection.vue?vue&type=template&id=552aada6&scoped=true&"
import script from "./JournalOrgSection.vue?vue&type=script&lang=js&"
export * from "./JournalOrgSection.vue?vue&type=script&lang=js&"
import style0 from "./JournalOrgSection.vue?vue&type=style&index=0&id=552aada6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552aada6",
  null
  
)

export default component.exports